<template>
  <div v-if="shortcuts && shortcuts.length > 0">
    <h4 class="s1-U__mg--bt16 s1-U__text-color--dark-2">{{ $t('shortcuts_and_actions') }}</h4>
    <div class="md-layout md-gutter">
      <s1vm-shortcut-item v-for="action in shortcuts" :key="action.name" :action="action"></s1vm-shortcut-item>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
  },
  computed: {
    shortcuts() {
      return this.$store.state.app && this.$store.state.app.shortcuts;
    }
  }
}
</script>